export default "__VITE_ASSET__c01bf4e9__"